import { Box } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthService } from 'shared/config/oidcClient/authServices';
import { getRouteHome, getRouteLogin } from 'shared/constants/routerConst';
import useAuth from 'shared/hooks/useAuth';

export const AuthRedirectPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const onRedirect = useCallback(async () => {
    try {
      const authService = new AuthService();
      const user = await authService.loginCallback();

      if (user) {
        await login(user);
        navigate(getRouteHome());
      } else {
        console.error('Auth redirect error: loginCallback returned null user');
        navigate(getRouteLogin());
      }
    } catch (error) {
      console.error('Auth redirect error:', error);
      navigate(getRouteLogin());
    }
  }, [login, navigate]);

  useEffect(() => {
    onRedirect();
  }, [onRedirect]);

  return <Box />;
};
